import { fuego } from '@nandorojo/swr-firestore';
import { CollectionPath } from '@typings/collections.enum';
import fire from '..';
import { deleteCollection } from '../collection/delete';

export async function removeNotification({ userId, notificationID }) {
  const ref = fuego.db.collection(CollectionPath.USERS).doc(userId);
  const notiRef = ref
    .collection(CollectionPath.NOTIFICATIONS)
    .doc(notificationID);

  return notiRef.delete();
}

export async function removeAllNoti({ userId }) {
  const ref = fuego.db.collection(CollectionPath.USERS).doc(userId);
  const notiRef = ref.collection(CollectionPath.NOTIFICATIONS);
  // Get a new write batch

  return deleteCollection({ collectionRef: notiRef });
}
